import { useApolloClient } from '@apollo/client';
import { GET_LATEST_ACTIVE_DOCUMENT } from '../../graphql/queries';

/** Payload from `getLatestActiveDocument` (includes file fields; not the active-documents list row). */
export interface LatestActiveDocumentFromApi {
  uuid: string;
  studyId?: string;
  patientId: string;
  carePlanId?: string;
  careActivityId?: string;
  typeId: string;
  name: string;
  status: string;
  base64File: string;
  fileType: string;
}

interface GetLatestActiveDocumentResponse {
  getLatestActiveDocument: LatestActiveDocumentFromApi | null;
}

interface GetLatestActiveDocumentVars {
  studyId?: string;
  carePlanId?: string;
  careActivityId?: string;
  typeId: string;
}

export const useGetLatestActiveDocument = (): {
  fetchDocument: (
    typeId: string,
    studyId?: string,
    carePlanId?: string,
    careActivityId?: string,
  ) => Promise<any>;
} => {
  const client = useApolloClient();

  const fetchDocument = async (
    typeId: string,
    studyId?: string,
    carePlanId?: string,
    careActivityId?: string,
  ) => {
    const variables: GetLatestActiveDocumentVars = { typeId };

    if (carePlanId && careActivityId) {
      variables.carePlanId = carePlanId;
      variables.careActivityId = careActivityId;
    } else if (studyId) {
      variables.studyId = studyId;
    }

    return client.query<GetLatestActiveDocumentResponse, GetLatestActiveDocumentVars>({
      query: GET_LATEST_ACTIVE_DOCUMENT,
      variables,
      fetchPolicy: 'no-cache',
    });
  };

  return {
    fetchDocument,
  };
};
